import { render, staticRenderFns } from "./downLoadModal.vue?vue&type=template&id=6e2b7cfa&scoped=true"
import script from "./downLoadModal.vue?vue&type=script&lang=js"
export * from "./downLoadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2b7cfa",
  null
  
)

export default component.exports